export default __webpack_public_path__ + "static/media/3.563a8192.jpg";